export class Timeline{
    num: string;
    title: string;
    element: Element[];
}

class Element{
    elementTitle: string;
    elementContents?: string[];
}